import { useQuery } from '@tanstack/react-query';
import { fetchLookupCanals } from '@api';
import { REGION_TYPES } from '@constants';

export const useLookupCanalsQuery = () => {
  return useQuery({
    queryKey: ['lookupCanals'],
    placeholderData: [],
    queryFn: ({ signal }) => {
      return fetchLookupCanals({ regionTypes: [REGION_TYPES.CANALS] }, signal)
        .then((resp) => resp)
        .catch(() => []);
    }
  });
};
